import React from 'react';
import { Typography } from '@material-ui/core';

export function PromoPanelTitle(props: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div style={props.style}>
      <Typography
        variant="h5"
        style={{
          fontWeight: 700,
          fontFamily: 'Editor',
          lineHeight: 1,
        }}
      >
        {props.children}
      </Typography>

      <div
        style={{
          width: '66px',
          height: '3px',
          backgroundColor: 'white',
          marginTop: '16px',
        }}
      />
    </div>
  );
}
